import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

// import QueueInputs from './components/QueueInputs';

import { accessLocalStorage, exportSelectAllEndpoints, exportSelectAllQueues, exportCreateQueueMembers, changeViewForms, valuesAnalyze, readAllTenant } from '../../../services';

import Loading from '../../Loading/LoadingModule';

import '../../../libs/bulma.min.css';
import './QueuesForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faUsers } from '@fortawesome/free-solid-svg-icons';

function MembersQueuesCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [endpoints, setEndpoints] = useState([]);
  const [queues, setQueues] = useState([]);
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [tenants, setTenants] = useState([]);
  

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  /*
    {
      queueName string
      endpointInit number,
      endpointFinal number,
      priority number,
      tenant string,
    }
  */

  const getEndpoints = async (idtenant) => {
    const endpointsList = await exportSelectAllEndpoints();
    if(endpointsList === undefined) return setLoading(true);

    let fetchedEndpoints = endpointsList.map((element) => element).filter((element) => !isNaN(Number(element.endpoint)));
    fetchedEndpoints = idtenant.includes('vgs') ? fetchedEndpoints : fetchedEndpoints.filter((endpoint) => idtenant.includes(endpoint.tenant));

    setEndpoints(fetchedEndpoints);
    setLoading(false);
  };
  

  const fetchQueues = async (idtenant) => {
    let queuesList = await exportSelectAllQueues();
    if(queuesList === undefined) return setLoading(true);   
    queuesList = idtenant.includes('vgs') ? queuesList : queuesList.filter((queue) => idtenant.includes(queue.accountcodequeue));
    queuesList = queuesList ? queuesList.map((s) => s.namequeue) : [];
    setQueues(queuesList);
    setLoading(false);
    return true;
  };

  const fetchTenants = async (idtenant) => {
    let tenantsList = await readAllTenant();
    if(tenantsList === undefined) return setLoading(true);
    tenantsList = idtenant.includes('vgs') ? tenantsList : tenantsList.filter((tenant) => idtenant.includes(tenant.short_name));
    setTenants(tenantsList);
    setLoading(false);
    return true;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    
    await getEndpoints(idtenant);
    await fetchQueues(idtenant);
    const tenants = await fetchTenants(idtenant);
    console.log(tenants);
  }, []);

  const changeScreen = (check, name) => {
    // changeBorderImputToRedOrNormal(check, name);
    // changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'endpointInit' || name === 'endpointFinal' || name === 'priority') {
      const checkValueIsNumber = checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    } else {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    };
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length >= 5) {
      Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    }
    return;
  };

  const sendDataQueueMembersGenerate = async () => {
    console.log(values);
    const fetchQueues = await exportCreateQueueMembers(values);

    const result = Object.keys(fetchQueues).length > 0 ? true : false;
    if(result) {
      changeVisibityMessages(false, 'success-create-queuesmembers');
      setTimeout(() => {
        // return window.location.reload(true);
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div className="queues-form-container">
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="queues-form-header">
            <div className="queues-form-title-wrapper">
              <svg className="queues-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <div>
                <h1 className="queues-form-title">Adicionar Ramal à Fila</h1>
                <p className="queues-form-subtitle">Configure membros dos grupos atendedores</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="success-create-queuesmembers" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#success-create-queuesmembers')}>×</button>
              </div>
              <div className="alert-body">
                Atribuição de membros a fila realizada com <strong>sucesso</strong>!
              </div>
            </div>
          </div>

          <div className="form-card">
            <div className="form-row">
              <div className="form-field form-field-small">
                <label className="form-label">Cliente</label>
                <div className="form-control">
                  <select className="form-select" name="tenant" onChange={(e) => handleChangeValues(e.target)}>
                    <option value="">Selecione</option>
                    {tenants.map((element) => <option key={element.short_name} value={element.short_name}>{element.name}</option>)}
                  </select>
                  <p name="tenant-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                </div>
              </div>

              <div className="form-field form-field-small">
                <label className="form-label">Ramal Inicial</label>
                <div className="form-control">
                  <select className="form-select" name="endpointInit" onChange={(e) => handleChangeValues(e.target)}>
                    <option value="">Selecione</option>
                    {endpoints.map((element) => <option key={element.endpoint} value={element.endpoint}>{element.endpoint}</option>)}
                  </select>
                  <p name="endpointInit-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                </div>
              </div>

              <div className="form-field form-field-small">
                <label className="form-label">Ramal Final</label>
                <div className="form-control">
                  <select className="form-select" name="endpointFinal" onChange={(e) => handleChangeValues(e.target)}>
                    <option value="">Selecione</option>
                    {endpoints.map((element) => <option key={element.endpoint} value={element.endpoint}>{element.endpoint}</option>)}
                  </select>
                  <p name="endpointFinal-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                </div>
              </div>

              <div className="form-field form-field-small">
                <label className="form-label">Fila</label>
                <div className="form-control">
                  <select className="form-select" name="queueName" onChange={(e) => handleChangeValues(e.target)}>
                    <option value="">Selecione</option>
                    {queues.map((queue) => <option key={queue} value={queue}>{queue}</option>)}
                  </select>
                  <p name="queueName-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                </div>
              </div>

              <div className="form-field form-field-small">
                <label className="form-label">Prioridade</label>
                <div className="form-control">
                  <input className="form-input" name="priority" type="number" onChange={(e) => handleChangeValues(e.target)} placeholder="0" />
                  <p name="priority-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-field form-field-medium">
                <label className="form-label">Nome do Atendente</label>
                <div className="form-control">
                  <input className="form-input" name="membername" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Nome do atendente (opcional)" />
                  <p name="membername-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                </div>
              </div>

              <div className="form-field form-field-small">
                <label className="form-label">Motivo da Pausa</label>
                <div className="form-control">
                  <input className="form-input" name="reason_paused" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Motivo da pausa (opcional)" />
                  <p name="reason_paused-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                </div>
              </div>

              <div className="form-field form-field-small">
                <label className="form-label">Ordem do Membro</label>
                <div className="form-control">
                  <input className="form-input" name="member_order" type="number" onChange={(e) => handleChangeValues(e.target)} placeholder="0" min="0" />
                  <p name="member_order-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button className="btn-submit" type="submit" disabled={disable} onClick={() => sendDataQueueMembersGenerate()}>
                <FontAwesomeIcon icon={faPhoneSquare} />
                <span>Adicionar Ramal ao Grupo Atendedor</span>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default MembersQueuesCreate;
